import { ReactNode } from 'react';
import { Dayjs } from 'dayjs';
import { TimeView } from '@mui/x-date-pickers/models';

export interface TimeRange {
  start: Dayjs | null;
  end: Dayjs | null;
}

// eslint-disable-next-line no-restricted-syntax -- passed as a JSX string by 6 screens; moving it to an enum is a separate task
type Mode = 'single' | 'multiple';

export enum TimeRangeEdgeEnum {
  Start = 'start',
  End = 'end'
}

export type TimeRangeEdge = `${TimeRangeEdgeEnum}`;

export interface TimeRangePickerListProps {
  updateData?: TimeRange[];
  onChange?: (ranges: TimeRange[]) => void;
  mode?: Mode;
  required?: boolean;
  helperText?: string;
  label?: string;
  tooltip?: string;
  minutesStep?: number;
  /** Highlights the ranges with the given indexes as invalid */
  rangeErrors?: boolean[];
  /** Per-range error text shown in the range helper line instead of helperText */
  rangeMessages?: string[];
  disabled?: boolean;
  disabledRanges?: boolean[];
  rangeAdornments?: ReactNode[];
  /** Sorts filled ranges by start time on change (default true) */
  sortRanges?: boolean;
  /** Emits an added empty range as well, so the parent can validate it */
  emitEmptyRanges?: boolean;
  shouldDisableTime?: (
    value: Dayjs,
    view: TimeView,
    edge: TimeRangeEdge,
    index: number
  ) => boolean;
}
